import * as St from '../OutageBanner.styles';
import { type ActiveBannerMessage } from '../useOutageBanner';
import SageIcon from '/public/assets/icons/sage-icon.svg';

export const ActiveOutageBanner = ({ title, message, lastUpdated }: {
  title: string;
  message: ActiveBannerMessage;
  lastUpdated: string;
}) => (
  <St.Overlay>
    <St.BannerBar data-type="outage">
      <St.Content>
        <St.TitleRow>
          <St.TitleText>{title}</St.TitleText>
        </St.TitleRow>
        <St.DescriptionRow>
          <St.BlackInfoIcon />
          <St.Description dangerouslySetInnerHTML={{ __html: message.html }} />
        </St.DescriptionRow>
      </St.Content>
      <St.BannerStatusBar>
        <div>{lastUpdated ? `Last updated: ${lastUpdated}` : ''}</div>
        <St.SageIconWrapper><SageIcon />The Sage Team</St.SageIconWrapper>
      </St.BannerStatusBar>
    </St.BannerBar>
  </St.Overlay>
);

export default ActiveOutageBanner;

